import React from "react";

import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";

import { HelpText } from "@/components/atoms";


interface GeoModeProps {
  readOnly?: boolean;
}

export const CustomerMode: React.FC<GeoModeProps> = ({ readOnly }) => {

  const theme = useTheme();

  return (
    <>
      <Grid size={12}>
        <HelpText
          text="Select File"
          helpText="Select the file you wish to upload, making sure that it adheres to the specific upload format"
          variant="body1"
        />
      </Grid>
      {!readOnly && (
        <Grid size={12}>
          <Stack spacing={1} sx={{ mb: 2 }}>
            <Typography>
              Upload a CSV file containing a postcode or sector column, along with a customer_id. Your file
              can also (optionally) include a segment column.
            </Typography>
            <Typography gutterBottom>
              An example file format is as follows
            </Typography>
            <Box sx={{ pt: 2 }}>
              <TableContainer component={Paper} sx={{ width: 360 }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{}}>
                      <TableCell
                        sx={{
                          fontFamily: "cera-pro-bold",
                          borderBottomColor: theme.palette.divider,
                        }}
                      >
                        postcode
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "cera-pro-bold",
                          borderBottomColor: theme.palette.divider,
                        }}
                      >
                        customer_id
                      </TableCell>
                      <TableCell
                        sx={{
                          fontFamily: "cera-pro-bold",
                          borderBottomColor: theme.palette.divider,
                        }}
                      >
                        segment
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ borderBottomColor: theme.palette.divider }}>
                        ABC 123
                      </TableCell>
                      <TableCell sx={{ borderBottomColor: theme.palette.divider }}>
                        Customer A
                      </TableCell>
                      <TableCell sx={{ borderBottomColor: theme.palette.divider }}>
                        Segment 1
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>ABC 123</TableCell>
                      <TableCell>Customer B</TableCell>
                      <TableCell>Segment 1</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>ABC 234</TableCell>
                      <TableCell>Customer C</TableCell>
                      <TableCell>Segment 1</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Stack>
        </Grid>
      )}
    </>
  );
};

export default CustomerMode;
